module.exports = __webpack_public_path__ + "0a9636d7896c4123ecbae528ab81a260.png";